import React from 'react'
import Text from './Text'
import {Img} from './Fields'
import Doc from './Doc'
import {renderVideo, formatDate, realPath} from '../lib/util'
import {fieldRenderer} from '../conf/fieldRenderer'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

const RealFieldRenderer = (props) => {
	const {field} = props
	if (field.render===null) return null
	
	let style = props.style?{...props.style}:{}
	if (field.ga && field.ga.trim()!=='') style.gridArea = field.ga
	else style.gridArea = field.name
	let fprops = {...props}
	fprops.style=style
	if(fieldRenderer[field.type]) {
		const Renderer = fieldRenderer[field.type]
		return <Renderer {...fprops}/>
	}
	
	switch(field.type) {
		case 'text':
			return <Text {...fprops} plain={true}/>
		case 'html':
			return <Text {...fprops}/>
		case 'img':
			return <Img {...fprops} classes={`field-${field.name}`} src={props.value}/>
		case 'date':
			if(!props.value) return null
			return <div className={`field-${field.name} date`}>{formatDate(props.value)}</div>
		case 'doc':
			return <Doc docs={props.value} {...fprops}/>
		case 'video':
			return renderVideo(props.value)
		case 'vid':
			if(!props.value || props.value.length===0) return null
			return <video playsInline autoPlay muted loop >
                <source src={realPath(props.value[0].url)} type="video/mp4"/>
            </video>
		case 'list': {
			if(!props.value) return null
			fprops.field = field.items
			delete fprops.value
			return <ul className={`field-${field.name} list`}>
				{props.value.map((val, i) => 
					<li key={i}><FieldRenderer {...fprops} value={val} path={props.path+'.'+i}/></li>
				)}
			</ul>
		}
		case 'obj': {
			if(!props.value) return null
			delete fprops.field
			delete fprops.value
			return <div className={`field-${field.name} obj`}>
				{field.fields.map((f, i) => 
					<div key={i}><FieldRenderer {...fprops} field={f} value={props.value[f.name]} path={props.path+'.'+f.name}/></div>
				)}
			</div>
		}
		//case 'action':
		//	return block[field.name] && <Link to={block[field.name].l} className='action' style={style}>{block[field.name].t}</Link>
		default:
			return null
	}
}
const FieldRenderer = (props) => {
	const {field} = props

	if (field.render===null) return null
	if (field.transition) {
		return <ReactCSSTransitionGroup
        			transitionName={field.name}
        			transitionEnterTimeout={400}
        			transitionLeaveTimeout={400}
        			transitionAppear={true}
      				transitionAppearTimeout={400}>
				<RealFieldRenderer key={props.entity._id['$oid']} {...props}/>
       		</ReactCSSTransitionGroup>
	}
	return <RealFieldRenderer {...props}/>
}
export default FieldRenderer


// WEBPACK FOOTER //
// ./src/fm/field/FieldRenderer.js